import PropTypes from 'prop-types';
import { startCase } from 'lodash';
// @mui
import { Stack, Link, TableRow, TableCell, Typography, Tooltip } from '@mui/material';
// components
import { fDateTime } from '../../../../../utils/formatTime';
import Iconify from '../../../../../components/Iconify';
import { getFileNameFromUrl } from '../../../../../utils/common';

// ----------------------------------------------------------------------

RetailKYCTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
};

const getStatusIcon = (value) => {
  const statusIcons = {
    not_done: 'eva:alert-circle-fill', // Icon for Pending
    complete: 'eva:checkmark-circle-fill', // Icon for Complete
    rejected: 'eva:close-circle-fill', // Icon for Rejected
    awaiting_approval: 'eva:clock-outline', // Icon for Application Submitted
    application_inprogress: 'eva:clock-outline', // Icon for Application In Progress
  };

  return statusIcons[value] || 'eva:clock-outline'; // Return default icon if status not found
};

const getStatusColor = (status) => {
  if (status === 'complete') return 'success.main';
  if (status === 'rejected') return 'error.main';
  return 'warning.main';
};

export default function RetailKYCTableRow({ row, selected }) {
  const {
    id,
    user,
    created_date,
    modified_date,
    application_id,
    document_type,
    back_part_of_document,
    front_part_of_document,
    selfie,
    status,
  } = row;

  return (
    <TableRow hover selected={selected}>
      <TableCell padding="checkbox">{id}</TableCell>
      <TableCell sx={{ display: 'flex', alignItems: 'left' }}>
        <Stack direction={'column'}>
          <Typography variant="subtitle2" noWrap>
            {user?.first_name} {user?.last_name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.disabled' }}>
            {user?.email}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell align="left">{`${user?.country?.dialing_code} ${user?.phone_number}`}</TableCell>
      <TableCell align="left">{fDateTime(created_date)}</TableCell>
      <TableCell align="left">{fDateTime(modified_date)}</TableCell>
      <TableCell align="left">{application_id}</TableCell>
      <TableCell align="center">{document_type ? startCase(document_type) : '--'}</TableCell>
      <TableCell align="center">
        {front_part_of_document ? (
          <Link
            href={front_part_of_document}
            variant="body2"
            target="_blank"
            underline="hover"
            sx={{ cursor: 'pointer' }}
          >
            {getFileNameFromUrl(front_part_of_document)}
          </Link>
        ) : (
          '--'
        )}
      </TableCell>
      <TableCell align="center">
        {back_part_of_document ? (
          <Link href={back_part_of_document} target="_blank" underline="hover" sx={{ cursor: 'pointer' }}>
            {getFileNameFromUrl(back_part_of_document)}
          </Link>
        ) : (
          '--'
        )}
      </TableCell>
      <TableCell align="center">
        {selfie ? (
          <Link href={selfie} target="_blank" underline="hover" sx={{ cursor: 'pointer' }}>
            {getFileNameFromUrl(selfie)}
          </Link>
        ) : (
          '--'
        )}
      </TableCell>
      <TableCell align="center">
        <Tooltip title={startCase(status)} placement="top" arrow>
          <span>
            <Iconify
              icon={getStatusIcon(status)}
              sx={{
                width: 20,
                height: 20,
                color: getStatusColor(status),
              }}
            />
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}
